module.exports = __webpack_public_path__ + "media/images/icons/material/google-37ac5ff290739bcad17e28b38ec85fcd.svg";